<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/07/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/07/profile_sp.png')"
    profileAlt="07 YUKITARO SAKAKIBARA"
    answer01="学生時代は情報理工学を専攻。化学の他に電子工学や情報工学についても学びました。研究室では超音波を利用した燃料電池用触媒の調製を目標に、反応装置の作成から触媒調整、電気化学評価に取り組んでいました。「音響化学」と呼ばれるジャンルで、学会員も国内200人程度しかいないマイナーな分野でしたが、その分新しい発見に満ちていて毎日楽しく研究していましたね。"
    answer02="化学メーカーを中心に就職活動をしていましたが、中でもクレハは樹脂、炭素材料、農薬、医薬品といった幅広い分野の製品を有しており、多分野を融合した研究ができることに魅力を感じました。また、少数精鋭の環境であることから、いろいろな場面で自分が活躍できる可能性があると感じたことも入社を決めた理由です。"
    answer03="入社1年目は電池の負極材料の開発を、２年目にバインダーの開発を担当し、現在はデジタル化推進プロジェクト（DXP）のメンバーとして社内基幹システムの刷新に携わっています。クレハ全体に関わる大きなプロジェクトなので、責任も大きいですがその分やりがいもあり、技術系出身者として各部署や研究所の橋渡し的な役割を担えるように意識しています。また、副業務として機械学習や深層学習を業務に適用させるために、社内データを用いた機械学習モデルの作成なども行っています。"
    answer04="まずは、現在携わっているプロジェクトを完遂させ、クレハグループの業務効率化と生産性向上を図ること。と言っても、海外のグループ会社も含めれば2025年頃までかかる大規模な案件なので、まだまだ先は長いです。最終的には、プロジェクトで得られた知識を活かして、業務において分析の高度化や機械学習の活用を検討していきたいと考えています。"
    answer05="色々なことをやらせてくれるところ。扱っている製品の幅が広いので様々な研究開発に携われますし、私のように全く違う職種にもチャレンジできる環境です。色々なことに好奇心を持って取り組みたい人には向いていると思います。また、福利厚生が充実していて働きやすいです。有給休暇を取得しやすい雰囲気がありますね。自分も、パフォーマンスが落ちてきたなと感じた日は早く帰ってリフレッシュし、メリハリをつけて働くように心がけています。"
    answer06="猫を飼っているので、平日面倒を見れていない分休日にブラシ掛けや遊び相手などをしています。また、お酒（特に蒸留酒）を飲むことが好きなので、行きつけの酒販店に行き、試飲をしながら好みのお酒を探すようなこともしばしばありますね。基本的に出かけることが好きで、通常の休日は電車での日帰り旅行だったり、連続休暇の際には春～秋は温泉旅行、冬はスノーボード旅行に出かけてリフレッシュしています。"
    :imageCut01="require('../../assets/img/lab/staff/07/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/07/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/07/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/07/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/07/schedule.svg')"
    :scheduleSp="require('../../assets/img/lab/staff/07/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
